import { render, staticRenderFns } from "./FCSProfile.vue?vue&type=template&id=04d4c792&scoped=true"
import script from "./FCSProfile.vue?vue&type=script&lang=js"
export * from "./FCSProfile.vue?vue&type=script&lang=js"
import style0 from "./FCSProfile.vue?vue&type=style&index=0&id=04d4c792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4c792",
  null
  
)

export default component.exports